import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EyebrowProps {
  children: ReactNode;
  className?: string;
  /** Color of the hairline rule and text. Defaults to current ink color. */
  tone?: "default" | "muted" | "inverse";
}

/**
 * Editorial eyebrow label — a 12px tracking-wide all-caps line
 * preceded by a 48px hairline rule. Mirrors the homepage section
 * intros and is the single-source primitive for that pattern.
 */
export const Eyebrow = ({ children, className, tone = "default" }: EyebrowProps) => {
  const palette =
    tone === "muted"
      ? "text-muted-foreground before:bg-muted-foreground/60"
      : tone === "inverse"
        ? "text-footer-foreground before:bg-footer-foreground"
        : "text-foreground before:bg-foreground";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.2em] font-display",
        "before:content-[''] before:h-px before:w-12",
        palette,
        className,
      )}
    >
      <span>{children}</span>
    </div>
  );
};
